import type { SVGAttributes } from 'react'

export type IconProps = {
	color?: string
	src: {
		id: string
		viewBox: string
	}
} & Omit<SVGAttributes<SVGElement>, 'color' | 'fill' | 'viewBox'>

export function Icon({
	className = '',
	color = 'var(--color-on-layer-primary)',
	role = 'none',
	src,
	style,
	...props
}: Readonly<IconProps>) {
	const [width, height] = src.viewBox.split(' ').slice(-2)

	return (
		<svg
			className={`flex-shrink-0 ${className}`}
			fill={color}
			height={props.height ?? height}
			role={role}
			style={style}
			viewBox={src.viewBox}
			width={props.width ?? width}
			{...props}
		>
			<use xlinkHref={`#${src.id}`} />
		</svg>
	)
}
